var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.059,
    height: 19.961,
    viewBox: "0 0 20.059 19.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.474,4.62l4.08,4.08L6.225,19.029l-4.078-4.08Zm7.177-.984-1.82-1.82a1.806,1.806,0,0,0-2.551,0L13.537,3.559l4.08,4.08,2.033-2.033A1.391,1.391,0,0,0,19.651,3.636ZM.012,20.684a.464.464,0,0,0,.562.552l4.547-1.1-4.078-4.08Z",
    transform: "translate(-0.001 -1.289)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditar);
export default __webpack_public_path__ + "static/media/ico-editar.265056515ecafa5cc82f17443f11696c.svg";
export { ForwardRef as ReactComponent };